module.exports = __webpack_public_path__ + "static/media/student_icon_black.0c572165.svg";